import axios from "axios";
import makeToast from "../components/Snackbar";
import { KATOMI_API_ENDPOINT } from "../config/api";
const jwt = require("jsonwebtoken");
export const baseURL = KATOMI_API_ENDPOINT;

const Client = axios.create({
  baseURL,
});

const REFRESH_WINDOW_MS = 15 * 60 * 1000;
const REFRESH_RETRY_COOLDOWN_MS = 60 * 1000;
let refreshInFlight: Promise<boolean> | null = null;
let lastRefreshFailureAt = 0;

export const refreshAccessToken = (): Promise<boolean> => {
  if (refreshInFlight) return refreshInFlight;
  if (Date.now() - lastRefreshFailureAt < REFRESH_RETRY_COOLDOWN_MS) {
    return Promise.resolve(false);
  }

  refreshInFlight = (async () => {
    try {
      const token = localStorage.getItem("token");
      const refreshToken = localStorage.getItem("refreshToken");
      if (!token || !refreshToken) return false;

      const res = await axios.get(`${baseURL}/auth/refresh-token`, {
        headers: { Authorization: `${token}||${refreshToken}` },
      });

      if (res && res.data && res.data.token) {
        localStorage.setItem("token", res.data.token);
        if (res.data.refreshToken) {
          localStorage.setItem("refreshToken", res.data.refreshToken);
        }
        return true;
      }
      lastRefreshFailureAt = Date.now();
      return false;
    } catch (error) {
      console.error("Token refresh failed", error);
      lastRefreshFailureAt = Date.now();
      return false;
    } finally {
      refreshInFlight = null;
    }
  })();

  return refreshInFlight;
};

export const tokenMsLeft = (): number | null => {
  const token = localStorage.getItem("token");
  if (!token) return null;
  const decoded = jwt.decode(token) as { exp?: number } | null;
  if (!decoded || !decoded.exp) return null;
  return decoded.exp * 1000 - Date.now();
};

export const ensureFreshToken = async (): Promise<void> => {
  const msLeft = tokenMsLeft();
  if (msLeft !== null && msLeft > 0 && msLeft < REFRESH_WINDOW_MS) {
    await refreshAccessToken();
  }
};

export const config = async (token): Promise<any> => {
  try {
    let token = localStorage.getItem("token");

    // Check if token exists and not expired
    if (token) {
      const decodedToken = jwt.decode(token) as { exp?: number };
      let refreshToken = localStorage.getItem("refreshToken");

      if (decodedToken.exp && decodedToken.exp * 1000 < Date.now()) {
        throw new Error("Token expired");
      }

      await ensureFreshToken();
      token = localStorage.getItem("token");
      refreshToken = localStorage.getItem("refreshToken");

      return {
        headers: {
          Authorization: `${token}||${refreshToken}`,
        },
      };
    }

    return { headers: {} };
  } catch (err) {
    console.error({ err });
    makeToast("error", "Failed to verify token validity");
    // redirect to login page or logout user
    localStorage.removeItem("token");
    return { headers: {} };
  }
};
export const configBlob = (token: string | null) => {
  return {
    headers: {
      Authorization: `${token}`,
      responseType: "arraybuffer",
    },
  };
};
export const config2 = (token: string | null) => {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },

    onUploadProgress: (progressEvent: { loaded: any }) =>
      console.log(progressEvent.loaded),
  };
};

export const configExcel = (token: string | null) => {
  return {
    headers: {
      Authorization: `${token}`,
      responseType: "arraybuffer",
      //"Content-Type": "blob"
    },
  };
};
// POST action
const post = async (url: string, data: any) => {
  try {
    const token = localStorage.getItem("token");
    //const tokenId = localStorage.getItem("idToken");

    let response;
    if (token) response = await Client.post(url, data, await config(token));
    else response = await Client.post(url, data);

    return response;
  } catch (err) {
    console.error({ err });
  }
};
//
const postExcel = async (url: string, data: any) => {
  try {
    const token = localStorage.getItem("token");
    //const tokenId = localStorage.getItem("idToken");

    let response;
    if (token) response = await Client.post(url, data, configExcel(token));
    else response = await Client.post(url, data);

    return response;
  } catch (err) {
    console.error({ err });
  }
};
// POST action
const post2 = async (url: string, data: any, onUploadProgress: any) => {
  try {
    const token = localStorage.getItem("token");
    //const tokenId = localStorage.getItem("idToken");
    let response;
    if (token) {
      response = await Client.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },

        onUploadProgress,
      });
    } else response = await Client.post(url, data);

    return response;
  } catch (err) {
    console.error({ err });
  }
};

// GET action
const get = async (url: string) => {
  try {
    const token = localStorage.getItem("token");
    //const tokenId = localStorage.getItem("idToken");
    let response;
    if (token) response = await Client.get(url, await config(token));
    else response = await Client.get(url, await config(token));

    return response.data;
  } catch (err) {
    console.error({ err });
  }
};

const getBlobFile = async (url: string) => {
  try {
    const token = localStorage.getItem("token");
    //const tokenId = localStorage.getItem("idToken");
    let response;
    if (token)
      response = await Client.get(url, {
        headers: {
          Authorization: `${token}`,
          responseType: "blob",
        },
      });
    else
      response = await Client.get(url, {
        headers: {
          Authorization: `${token}`,
          responseType: "blob",
        },
      });

    return response.data;
  } catch (err) {
    console.error({ err });
  }
};

const getBlob = async (url: string) => {
  try {
    const token = localStorage.getItem("token");
    //const tokenId = localStorage.getItem("idToken");
    let response;
    if (token) response = await Client.get(url, configBlob(token));
    else response = await Client.get(url, configBlob(token));
    return response.data;
  } catch (err) {
    console.error({ err });
  }
};

// PATCH action
const patch = async (url: string, data: any) => {
  try {
    const token = localStorage.getItem("token");
    //const tokenId = localStorage.getItem("idToken");
    let response;
    if (token) response = await Client.patch(url, data, await config(token));
    else response = await Client.patch(url, data);
    return response.data;
  } catch (err) {
    console.error({ err });
  }
};
const update = async (url: string, data: any) => {
  try {
    const token = localStorage.getItem("token");
    //const tokenId = localStorage.getItem("idToken");
    let response;
    if (token) response = await Client.put(url, data, await config(token));
    else response = await Client.put(url, data);
    return response.data;
  } catch (err) {
    console.error({ err });
  }
};

// DELETE action
const remove = async (url: string) => {
  try {
    const token = localStorage.getItem("token");
    //const tokenId = localStorage.getItem("idToken");
    let response;
    if (token) response = await Client.delete(url, await config(token));
    else response = await Client.delete(url);
    return response.data;
  } catch (err) {
    console.error({ err });
  }
};

export {
  Client,
  get,
  post,
  remove,
  patch,
  update,
  post2,
  getBlob,
  getBlobFile,
  postExcel,
};
